<template>
  <div class="spacing">
    <full-view-spinner :show="inProgress" />
    <a
      class="dtva-header__nav-entry"
      href=""
      @click.prevent="logout"
    >
      {{ this.$i18n.t('PROFILE.LOGOUT') }}
    </a>
  </div>
</template>

<script>

export default {
  name: 'LogoutButton',
  components: {  },
  data: function() {
    return {
      inProgress: false,
    }
  },
  methods: {
    logout: function() {
      this.inProgress = true;
      // try to remove token on server
      this.$http.delete('api/accessToken', null).finally(
        () => {
        //this.$store.dispatch("googleAnalytics/createGoogleAnalyticsEvent", {eventCategory: 'Account', eventAction: 'Logout', eventLabel: 'Success'});
        this.inProgress = false;
        // whatever the result is, delete token locally
        this.$store.commit("clearAllStoreData")
        this.$router.push({name: 'landing'});
        })
    }
  },
};
</script>

<style lang="scss" src="../loading/loading.scss">
</style>
